<script>
  import Page from 'page'
  let NavClass = 'collapse navbar-collapse d-lg-flex justify-content-lg-end'

  let logInInformation = false

  JSON.parse(localStorage.getItem('loginData')) === null
    ? (logInInformation = false)
    : (logInInformation = true)

  function toggleNav() {
    NavClass == 'collapse navbar-collapse d-lg-flex justify-content-lg-end'
      ? (NavClass = 'collapse navbar-collapse show')
      : (NavClass = 'collapse navbar-collapse d-lg-flex justify-content-lg-end')
  }
</script>

<!-- As a link -->
<nav class="navbar2 navbar-expand">
  <div class="d-lg-flex justify-content-lg-end" id="navbarNav">
    <ul class="navbar-nav d-sm-flex justify-content-center">
      {#if logInInformation}
        <li class="nav-item">
          <a class="nav-link" href="/logout">logout</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="/">|</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="/login">Member Section</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/">|</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/matrimonial">Matrimonial</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/">|</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/matrimonialsearch">Matrimonial Search</a>
        </li>
      {:else}
        <li class="nav-item">
          <a class="nav-link" href="/login">Login</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="/">|</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="/signup">Member Signup</a>
        </li>
      {/if}
    </ul>
  </div>
</nav>
<nav class="navbar navbar-expand-lg">
  <a class="navbar-brand" href="/">
    <img width="250px" class="d-logo" src="../assets/logo.png" alt="" />
  </a>
  <button on:click="{toggleNav}" class="d-lg-none btn" type="button">
    <img src="../assets/images/dash.svg" alt="" />
  </button>
  <div class="{NavClass}" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" href="/">Home</a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="/about">About</a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="/services">Services</a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="/events">Events</a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="/history">Our History</a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="/contact">Contact Us</a>
      </li>
      <li class="nav-item">
        <a
          target="_blank"
          class="nav-link"
          href="https://www.paypal.com/donate?hosted_button_id=B92PRTS5PVWP8"
          >Donate Us</a>
      </li>
    </ul>
  </div>
</nav>

<style lang="scss">
  .navbar-brand {
    background-color: #fff;
    height: 100%;
    display: block;
    margin-left: 10px;
  }
  .d-logo {
    background-color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
  }
  .navbar-toggler:focus {
    outline: none;
  }
  .navbar2 {
    background-color: #fff;
    border-bottom: solid 2px #ff9933;
    a {
      color: #ff9933;
      padding: 5px 15px;
    }
  }
  .navbar {
    padding: 0px;
    background-color: #ff9933;
    color: #fff;
    border-bottom: solid 2px #ff9933;

    .bt-n {
      border: none;
      background-color: #ff9933;
      color: #fff;
      &:hover {
        text-decoration: underline solid 4px #fff;
      }
    }

    a {
      color: #fff;

      &:hover {
        text-decoration: underline solid 4px #fff;
      }
    }
  }
</style>
